/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioIntervalTimeUnit {
    HOUR = 'HOUR',
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH'
}


export function instanceOfInternalApiScenarioIntervalTimeUnit(value: any): boolean {
    for (const key in InternalApiScenarioIntervalTimeUnit) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioIntervalTimeUnit, key)) {
            if (InternalApiScenarioIntervalTimeUnit[key as keyof typeof InternalApiScenarioIntervalTimeUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioIntervalTimeUnitFromJSON(json: any): InternalApiScenarioIntervalTimeUnit {
    return InternalApiScenarioIntervalTimeUnitFromJSONTyped(json, false);
}

export function InternalApiScenarioIntervalTimeUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioIntervalTimeUnit {
    return json as InternalApiScenarioIntervalTimeUnit;
}

export function InternalApiScenarioIntervalTimeUnitToJSON(value?: InternalApiScenarioIntervalTimeUnit | null): any {
    return value as any;
}

export function InternalApiScenarioIntervalTimeUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioIntervalTimeUnit {
    return value as InternalApiScenarioIntervalTimeUnit;
}

